import { render, staticRenderFns } from "./TaxonomiesView.vue?vue&type=template&id=e78e41b2"
import script from "./TaxonomiesView.vue?vue&type=script&lang=js"
export * from "./TaxonomiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports